import {useEffect,useState} from "react"
import axios from "axios"
import "./style.scss"
import SelectEodStep from "./SelectEodStep";
import ReviewCouponsStep from "./ReviewCouponsStep"
import ConfirmSendStep from "./ConfirmSendStep";
import DoneStep from "./DoneStep";


const NewspaperCoupons =  () => {
  const url = process.env.REACT_APP_DEPPLOYED;
  const [submissionId,setSubmissionId] = useState()
  const [message,setMessage]= useState();
  const [barcodes,setBarcodes] = useState([]);
  const [totalCouponsCost, setTotalCouponsCost] = useState()
  const [step, setStep] = useState(0);
  const [selectedEods,setSelectedEods] = useState()
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState({
    siteId: null,
    siteName: null,
  });
    const [userData,setUserData] = useState({
    user:null,
    role:null
  })

  useEffect(async () => {
    let userD = localStorage.getItem("userDetails");
    let user = JSON.parse(userD);
    setUserData((prev) => ({
      ...prev,
      user: user?.user?.user,
      role: user?.user?.role,
    }));
    await axios
      .post(`${url}/eposSQL/getSitesByName`, {
        sites: user.user.sites,
      })
      .then((res) => {
        if (res.data.length === 1) {
          setSelectedSite((prev) => ({
            ...prev,
            siteId: res.data[0].eposId,
            siteName: res.data[0].siteName,
          }));
        } else {
          setSites(res.data);
        }
      })
      .catch((error) => {
        console.log("Error", error);
      });
  }, []);

  const handleSiteChange = (e) => {
    const selectedOption = e.target.selectedOptions[0];
    const newSite = {
      siteId: e.target.value,
      siteName: selectedOption.getAttribute("siteName"),
    };
    setSelectedSite((prev) => ({
      ...prev,
      ...newSite,
    }));
  };

  const handleStepChange=()=>{
    if(selectedSite.siteId!==null &&selectedSite.siteId!=="--Select Site--" ){
      setMessage()
      setStep(1);
    }else{
      setMessage("Please select site")
    }
  }

  return (
    <div className="menzies-wizard">
      <h1 className="">Menzies Returns </h1>
      {step === 0 && (
        <>
          {sites.length > 1 ? (
            <div>
              {message && <p>Please select site</p>}
              <div className="site-select-container">
                <h2>Select site</h2>
                <select onChange={handleSiteChange}>
                  <option>--Select Site--</option>
                  {sites.map(function (site, i) {
                    return (
                      <option
                        key={site.eposId}
                        value={site.eposId}
                        siteName={site.siteName}
                      >
                        {site.siteName}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>
          ) : (
            <h2>
              Coupons for:{" "}
              <span style={{ color: "#2c53a0" }}>{selectedSite.siteName}</span>
            </h2>
          )}
          <div className="single-btn-box">
            <button className="btn" onClick={handleStepChange}>
              Next
            </button>
          </div>
        </>
      )}

      {step === 1 && (
        <SelectEodStep
          onNext={(selectedEods) => {
            setSelectedEods(selectedEods);
            setStep(2);
          }}
          onBack={() => setStep(0)}
          site={selectedSite}
          url={url}
        />
      )}

      {step === 2 && selectedEods && (
        <ReviewCouponsStep
          eodIds={selectedEods}
          onNext={() => setStep(3)}
          onBack={() => setStep(1)}
          url={url}
          setBarcodes={setBarcodes}
          setSubmissionId={setSubmissionId}
          setTotalCouponsCost={setTotalCouponsCost}
        />
      )}

      {step === 3 && selectedEods && (
        <ConfirmSendStep
          eodIds={selectedEods}
          onNext={() => setStep(4)}
          onBack={() => setStep(2)}
          url={url}
          barcodes={barcodes}
          submissionId={submissionId}
          totalCouponsCost={totalCouponsCost}
        />
      )}

      {step === 4 && selectedEods && (
        <DoneStep eodIds={selectedEods} onRestart={() => setStep(0)} />
      )}
    </div>
  );
};
export default NewspaperCoupons